import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { assetInstanceQueryOptions } from "@/services/asset";

/**
 * Thin org Asset instance layout — shared params / soft prefetch for drawer tabs.
 * Drawer chrome lives in the pathless `_drawer` layout.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId",
)({
	params: {
		parse: (params) => ({
			assetId: z.string().parse(params.assetId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(`/assets/${params.assetId}`);
		if (exactRoot) {
			throw redirect({
				to: "/web/$orgId/assets/$assetId/details",
				params: {
					orgId: params.orgId,
					assetId: params.assetId,
				},
				search: {},
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.prefetchQuery(
			assetInstanceQueryOptions.detail(params.assetId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: AssetIdLayout,
});

function AssetIdLayout() {
	return <Outlet />;
}
